// Size-guide lightbox — click the PDP "Size guide" link to view the size chart
// image in an overlay instead of navigating away. Reuses the .pod-lightbox
// overlay styles. Falls back to the link's href (opens image) if JS is off.
(function () {
  function openGuide(url) {
    var overlay = document.createElement('div');
    overlay.className = 'pod-lightbox';
    overlay.innerHTML =
      '<button class="pod-lightbox-close" aria-label="Close">&times;</button>' +
      '<img src="' + url + '" alt="Size guide">';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    function close() {
      overlay.remove();
      document.body.style.overflow = '';
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.pod-lightbox-close').addEventListener('click', close);
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-size-guide]');
    if (link) { e.preventDefault(); openGuide(link.href); }
  });
})();
